import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18next from 'i18next';
import { ModalCloseButton, ModalHeader, ModalTitle } from '@famly/mf_modals-dialogs_modal';
import { FormHeaderDebug } from '@famly/stat_forms_form-header';
export const CustomKinderConnectCaptureHeader = ({ onClose }) => {
    return (_jsxs(ModalHeader, { children: [_jsx(ModalTitle, { title: i18next.t($ => $.stat.kinderConnectCapture.businessLogic.src.translations.json.title) }), _jsx(ModalCloseButton, { onClose: () => onClose === null || onClose === void 0 ? void 0 : onClose() }), _jsx(FormHeaderDebug, {})] }));
};
